import React from 'react';
import { PageView } from '../view';
import { QuestionConfiguration, IQuestionConfigurator } from '../../survey.types';

export class PageConfigurator {
  questions: IQuestionConfigurator[];
  style: any;
  serverContext: any;
  i18n: any;
  surveyConfigurator: any;

  constructor({ serverContext, i18n, surveyConfigurator }) {
    this.questions = [];
    this.serverContext = serverContext;
    this.i18n = i18n;
    this.surveyConfigurator = surveyConfigurator;
  }

  // sort questions by position
  sortQuestions(): void {
    this.questions.sort((a, b) => a.position - b.position);
  }

  // add question to page
  addQuestion(questionConfiguration: QuestionConfiguration): IQuestionConfigurator {
    const {
      Type,
    } = questionConfiguration;
    const question = new Type({
      configuration: questionConfiguration,
      serverContext: this.serverContext,
      i18n: this.i18n,
      surveyConfigurator: this.surveyConfigurator,
    });
    this.questions.push(question);
    return question;
  }

  isVisible(answers: Object): boolean {
    for (let i = 0; i < this.questions.length; i += 1) {
      if (this.questions[i].isVisible(answers)) {
        return true;
      }
    }
    return false;
  }

  // determine if page is valid, delegating to questions
  isValid(answers: Object): boolean {
    for (let i = 0; i < this.questions.length; i += 1) {
      if (!this.questions[i].isValid(answers)) {
        return false;
      }
    }
    return true;
  }

  // get the feedback data for sending to the OCV service
  getFeedbackData(answers: Object): any {
    const remaining: Array<Object> = [];
    const comments: Array<Object> = [];
    let email = null;
    let rating = null;

    this.questions.forEach((question) => {
      if (question.isVisible(answers)) {
        if (question.isEmail()) {
          email = question.getFeedbackData(answers);
        } else if (question.isRating()) {
          rating = question.getFeedbackData(answers);
        } else if (question.isComment()) {
          comments.push(question.getFeedbackData(answers));
        } else {
          // single-selection, multiple-selection
          remaining.push(question.getFeedbackData(answers));
        }
      }
    });

    return {
      rating,
      email,
      remaining,
      comments,
    };
  }

  // get the view for the page
  getView(): (props: any) => JSX.Element {
    return props =>
      (<PageView
        {...props}
        configurator={this}
      />);
  }
}
